const newId = () => `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

export async function claimTabIdentity(signal) {
  let id;
  try {
    id = sessionStorage.getItem('fdc-realtime-tab') || newId();
  } catch {
    id = newId();
  }
  if (navigator.locks) {
    while (!signal.aborted) {
      const candidate = id;
      const acquired = await new Promise((resolve) => {
        navigator.locks.request(`fdc-realtime:${candidate}`, {ifAvailable: true}, async (lock) => {
          if (!lock || signal.aborted) {
            resolve(false);
            return;
          }
          resolve(true);
          await new Promise((release) => {
            if (signal.aborted) release();
            else signal.addEventListener('abort', release, {once: true});
          });
        }).catch(() => resolve(null));
      });
      if (acquired) break;
      id = newId();
      if (acquired === null) break;
    }
  } else {
    // Without browser locks, use a fresh identity rather than evict another tab.
    id = newId();
  }
  try {
    sessionStorage.setItem('fdc-realtime-tab', id);
  } catch {}
  return id;
}
